import * as React from 'react';
import {useTranslation} from 'react-i18next';
import errorStateIcon from '../ErrorStatePage/errorState.inline.svg';
import {Button} from '../ui/Button/Button';
import {SmallParagraph} from '../ui/SmallParagraph/SmallParagraph';
import {SVGIcon} from '../ui/SVGIcon';
import {Title} from '../ui/Title';
import styles from './PaymentErrorState.scss';
import {IOuter} from './PaymentErrorState.types';

export const PaymentErrorState: React.FunctionComponent<IOuter> = ({message, onRetryClick}) => {
  const {t} = useTranslation();

  return (
    <div className={styles.paymentErrorState} data-hook="payment-error-state">
      <div className={styles.paymentErrorStateIconContainer}>
        <SVGIcon className={styles.paymentErrorStateIcon} Svg={errorStateIcon} accHidden />
      </div>
      <Title className={styles.paymentErrorStateTitle}>{t('mgw.paymentDidntGoTitle')}</Title>
      <SmallParagraph className={styles.paymentErrorStateSubtitle}>
        {message || t('mgw.paymentDidntGoSubtitle')}
      </SmallParagraph>
      <Button onClick={onRetryClick} className={styles.retryButton} theme="big" dataHook="retry-button">
        {t('mgw.errorState.retryButton')}
      </Button>
    </div>
  );
};

PaymentErrorState.displayName = 'PaymentErrorState';
